var render = function render(){var _vm=this,_c=_vm._self._c;return _c('no-ssr',[(_vm.isShow)?_c('a',{staticClass:"actBar",attrs:{"href":_vm.actLink,"target":"_blank"}},[_c('div',{staticClass:"inner_center"},[_c('i',{staticClass:"iconfont icon-cha",on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.close.apply(null, arguments)}}})])]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }